import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
} from "@tanstack/react-query";
import {
  getVenueStripeAccountStatus,
  startVenueStripeOnboarding,
} from "../client/manager/venue-stripe-account";
import type {
  VenueStripeAccountStatus,
  VenueStripeOnboardingLink,
} from "../models/venue-stripe-account";

/**
 * A venue's Stripe Connect status. The GET syncs from ticketing-api on every
 * call, so it is always refetched on mount — the manager may have just come
 * back from Stripe.
 */
export function useVenueStripeAccount(
  venuePageId: string
): UseQueryResult<VenueStripeAccountStatus> {
  return useQuery({
    queryKey: ["venue", venuePageId, "stripe-account"],
    queryFn: () => getVenueStripeAccountStatus(venuePageId),
    enabled: !!venuePageId,
    staleTime: 0,
    retry: false,
  });
}

/** Mint an onboarding link; the caller redirects the browser to it. */
export function useStartVenueStripeOnboarding(
  venuePageId: string
): UseMutationResult<VenueStripeOnboardingLink, Error, string> {
  return useMutation({
    mutationFn: (returnUrl: string) =>
      startVenueStripeOnboarding(venuePageId, returnUrl),
  });
}
